import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostListener, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { Actions, TableColumn } from '@app/shared/table/TableColumn';
import { ConfirmDialogComponent } from '@app/shared/components/confirm-dialog/confirm-dialog.component';
import { DELETE_CONFIRMATION } from '@app/shared/constants/application-constants';

import { AddAdminComponent } from '@app-admin/dialogs/add-admin/add-admin.component';
import { DialogService } from '@app-admin/dialogs/dialog.service';
import { UtilService } from '@app-shared/services/util.service';
import { DeleteService } from '@app/shared/table/delete.service';
import { GetAllService } from '@app/shared/table/getAll.service';
import { UpdateStatusService } from '@app/shared/table/updateStatus.service';

declare var $: any;
@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-manage-admins',
    templateUrl: './manage-admins.component.html',
    styleUrls: ['./manage-admins.component.css'],
    standalone: false
})
export class ManageAdminsComponent implements OnInit {
   @ViewChild(ConfirmDialogComponent) confirmDialog: ConfirmDialogComponent;
   @HostListener('document:click', ['$event'])
    closeMenus(event: MouseEvent) {
      const target = event.target as HTMLElement;
  
      // Check if click was inside the open menu
      const insideMenu = target.closest('.mat-menu-panel');
  
      // Check if click was on a menu trigger button
      const menuBtn = target.closest('[mat-menu-trigger-for]') || 
                      target.closest('button[mat-icon-button]');
  
      // Only hide if it's NOT inside menu and NOT on trigger
      if (!insideMenu && !menuBtn) {
        document.querySelectorAll('.mat-menu-panel').forEach(menu => {
          (menu as HTMLElement).style.display = 'none';
        });
      }
    }

  displayedColumns: string[] = ['sno', 'name', 'email', 'phone', 'designation', 'location', 'is_active', 'action'];
   warningMessage = DELETE_CONFIRMATION;
  dataSource: MatTableDataSource<any>;
  UserId: any = parseInt(localStorage.getItem('superUserId'));
  isOrgSuperAdmin: boolean = JSON.parse(localStorage.getItem('isOrgSuperAdmin'));
  isSuperAdmin: boolean;
  selectedAdminToDelete: any;
  serviceError: string;
  isLoading = true;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private srvc: DialogService,
    private util: UtilService,
    private dialog: MatDialog,
    private route: Router,
    private cdr: ChangeDetectorRef,
    private deleteService: DeleteService,
    private updateStatusService: UpdateStatusService,
    private getAllService: GetAllService
  ) {
  }

  get tableColumnPageType(): string {
    return `manage-admins-${this.data}`;
  }

  tableColumns: Array<TableColumn> = [
    { name: 'S.No.', dataKey: 'sno', type: 'text', isSortable: true },
    { name: 'Name', dataKey: 'name', type: 'text', isSortable: true },
    { name: 'Email', dataKey: 'email', type: 'text', isSortable: true },
    { name: 'Phone', dataKey: 'phone', type: 'text', isSortable: true },
    { name: 'Designation', dataKey: 'designation', type: 'text', isSortable: true },
    { name: 'Location', dataKey: 'location', type: 'text', isSortable: true },
    { name: 'Status', dataKey: 'is_active', type: 'toogle', isSortable: false,  isFilterable: true,
    conditionalNaming: {
        true: { name: 'Active', checked: true },
        false: { name: 'Inactive', checked: false },
        1: { name: 'Active', checked: true },
        0: { name: 'Inactive', checked: false },
      },
     },
    // Org Super Admin column will be conditionally added in ngOnInit
    {
      name: 'Actions',
      type: 'threeDotActions',
      rowActions: [
        { iconName: 'edit', iconTooltip: 'Modify Admin', name: 'edit' },
        { iconName: 'history', iconTooltip: 'Show Revision History', name: 'history' },
        { iconName: 'trash', iconTooltip: 'Delete Admin', name: 'delete' }
      ]
    }
  ];

    filterAttributes = [
    {
      dataKeyName: 'name',
      name: 'Name',
      type: 'text'
    },
    {
      dataKeyName: 'status',
      name: 'Status',
      type: 'status',
      data: ['Active', 'Inactive'],
    },
    {
      dataKeyName: 'org_admin_status',
      name: 'Org Super Admin',
      type: 'static',
      data: ['Active', 'Inactive'],
    },
    {
      dataKeyName: 'all',
      name: 'All Text',
      type: 'all',
      data: ['Name', 'Email', 'Phone', 'Designation', 'Location'],
    },
  ];

  tableActions: Array<Actions> = [
    { iconName: 'plus', iconTooltip: 'Add Admin', name: 'add' }
  ];

    rowAction(event: any) {
    switch (event.rowName) {
      case 'edit':
        this.modifyAdmin(event.row.id);
        break;
      case 'history':
        this.showRevisionHistory(event.row);
        break;
      case 'delete':
        this.deleteAdmin(event.row.id);
        break;
      default:
        break;
    }
  }

  

  tableActionEmitter(event: any) {
    if (event === 'add') {
      this.addAdminPopup();
    }
  }

  ngOnInit(): void {
    this.isSuperAdmin = this.util.decrypt(localStorage.getItem('ur')) === 'SA';
    if (this.isSuperAdmin) {
      const colLength = this.displayedColumns.length;
      this.displayedColumns.splice(colLength - 1, 0, 'is_org_admin');
      // Add Org Super Admin column to tableColumns
      this.tableColumns.splice(this.tableColumns.length - 1, 0, {
        name: 'Org Super Admin',
        dataKey: 'is_org_admin',
        type: 'toogle',
        isSortable: false,
        conditionalNaming: {
          true: { name: 'Active', checked: true },
          false: { name: 'Inactive', checked: false },
          1: { name: 'Active', checked: true },
          0: { name: 'Inactive', checked: false },
        }
      });
    }
    this.dataSource = new MatTableDataSource([]);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.getAllAdmins();
  }

  onToggleChange(event: { row: any, checked: boolean, column: string }) {
    if (event.column === 'is_active') {
      this.replaceRowInDataSource(event.row.id, { is_active: event.checked });
      this.updateStatus(event, event.row.id);
    } else if (event.column === 'is_org_admin') {
      this.replaceRowInDataSource(event.row.id, {
        is_org_admin: event.checked,
        org_admin_status: event.checked ? 'Active' : 'Inactive'
      });
      this.updateOrgAdmin(event, event.row.id);
    }
  }

  private replaceRowInDataSource(id: number, changes: Partial<any>): void {
    const updatedData = this.dataSource.data.map(row =>
      row.id === id ? { ...row, ...changes } : row
    );
    this.dataSource.data = updatedData;
    this.cdr.markForCheck();
  }

  getAllAdmins() {
    this.getAllService.getAdmin(this.data).subscribe(
      (data: any) => {
         this.isLoading = false; 
        data.body.responseBody.sort((a, b) => a.id - b.id);
        const tableData = data.body.responseBody.map((i, index) => {
          i.sno = index + 1;
          i.name = i.full_name;
          i.location = `${i.district_name}, ${i.state_name}`;
          i.org_admin_status = i.is_org_admin ? 'Active' : 'Inactive';
          delete i['full_name'];
          return i;
        });
        if (tableData && tableData.length) {
          const loginAdminIndex = tableData.findIndex((ele) => ele.id === this.UserId);
          if (loginAdminIndex !== -1) {
            tableData.splice(loginAdminIndex, 1);
          }
        }
        this.dataSource.data = tableData;
        this.dataSource._updateChangeSubscription();
        this.cdr.markForCheck();
      },
      (err: any) => {
        this.util.errorNotification(err);
        this.isLoading = false;
        this.cdr.markForCheck();
      }
    );
  }

  addAdminPopup(data?: any) {
    this.dialog.closeAll();
    const dialogRef = this.dialog.open(AddAdminComponent, {
      width: 'min(1000px, 92vw)',
      autoFocus: false,
      panelClass: ['no-shadow-dialog'],
      backdropClass: 'no-shadow-dialog-backdrop',
      data: data || { orgId: this.data }
    });
      dialogRef.afterClosed().subscribe(result => {
        this.dialog.open(ManageAdminsComponent, {
          width: 'min(1200px, 92vw)',
          maxWidth: '1200px',
          panelClass: 'manage-admin-dialog',
          data: this.data,
          autoFocus: false,
        });
      });
  }

  modifyAdmin(id) {
    this.srvc.getAdminById(parseInt(id)).subscribe(
      (data: any) => {
        this.addAdminPopup(data.body.responseBody);
      },
      (err: any) => {
        this.util.errorNotification(err);
        this.cdr.markForCheck();
      }
    );
  }

showRevisionHistory(row: any) {
  this.dialog.closeAll();
  
  try {
    // Try to get org info from localStorage (works for both flows)
    const storedOrg = localStorage.getItem('SelectedOrgForRevision');
    let orgId;
    
    if (storedOrg) {
      // Check if it's encrypted (org-list flow)
      if (storedOrg.startsWith('U2FsdGVkX1')) { // Typical encrypted prefix
        const decrypted = this.util.decrypt(storedOrg);
        orgId = JSON.parse(decrypted).id;
      } else {
        // Direct JSON (edit-org flow)
        orgId = JSON.parse(storedOrg).id;
      }
    }

    if (!orgId) {
      throw new Error('Organization ID not found');
    }

    this.route.navigate(
      ['/admin/org-admin/RevisionHistory', row.id, row.name],
      { queryParams: { orgId: orgId } }
    ).catch(err => {
      console.error('Navigation failed:', err);
      this.util.simpleDialog({
        title: 'Error',
        message: 'Could not open revision history'
      });
    });

  } catch (error) {
    console.error('Error showing revision history:', error);
    this.util.simpleDialog({
      title: 'Error',
      message: 'Failed to load organization information'
    });
  }
}

  // applyFilter(event: Event) {
  //   const filterValue = (event.target as HTMLInputElement).value;
  //   this.dataSource.filter = filterValue.trim().toLowerCase();

  //   if (this.dataSource.paginator) {
  //     this.dataSource.paginator.firstPage();
  //   }
  // }

  updateStatus(event, id: number) {
    this.updateStatusService.updateStatus(event, id, false, 'adminStatus').subscribe((data: any) => {
      const responseHead = data.body.responseHead;
      const successMsg = responseHead ? this.util.getSuccessMessage('UPDATE_ADMIN_STATUS', responseHead.statusCode, responseHead.statusDesc) : responseHead;
      this.util.simpleDialog({
        title: 'Updated',
        message: successMsg,
      });
      this.getAllAdmins();
      // this.route.navigate(['/admin/org-list']);
      this.util.showLoader = false;
    }, (err) => {
      this.util.showLoader = false;
      this.serviceError = err.responseHead
        ? this.util.getIntlErrorMessage("MANAGE_ADMINS", err.responseHead.statusCode, err.responseHead.statusDesc)
        : err;
      this.util.simpleDialog({
        title: 'Error',
        message: this.serviceError,
      });
      this.route.navigate(['/admin/org-list']);
    });
  }

  updateOrgAdmin(event, id: number) {
    this.updateStatusService.updateStatus(event, id, false, 'updateOrgAdmin').subscribe((res: any) => {
      const responseHead = res.body.responseHead;
      const successMsg = responseHead ? this.util.getSuccessMessage('UPDATE_ADMIN_ROLE', responseHead.statusCode, responseHead.statusDesc) : responseHead;
      this.util.simpleDialog({
        title: 'Updated',
        message: successMsg,
      });
      this.route.navigate(['/admin/org-list']);
      this.util.showLoader = false;
    }, (err) => {
      this.util.showLoader = false;
      this.serviceError = err.responseHead
        ? this.util.getIntlErrorMessage("MANAGE_ADMINS", err.responseHead.statusCode, err.responseHead.statusDesc)
        : err;
      this.util.simpleDialog({
        title: 'Error',
        message: this.serviceError,
      });
      this.route.navigate(['/admin/org-list']);
    });
  }

 deleteAdmin(id: number) {
      this.selectedAdminToDelete = id; // Store the course to be deleted
      const modal = document.getElementById('confirmDialogModal');
      if (modal) {
        (modal as any).classList.add('show');
        modal.setAttribute('aria-hidden', 'false');
        modal.style.display = 'block';
      }
  }

   onConfirmDelete(): void {
    if (this.selectedAdminToDelete) {
    const postData = {
      impactedRowId: this.selectedAdminToDelete,
    };
    this.deleteService.delete(postData, 'deleteAdmin').subscribe((data: any) => {
      const responseHead = data.body.responseHead;
      const successMsg = responseHead ? this.util.getSuccessMessage('DELETE_ADMIN', responseHead.statusCode, responseHead.statusDesc) : responseHead;
      this.util.simpleDialog({
        title: 'Deleted',
        message: successMsg,
      });
      this.getAllAdmins();
      this.route.navigate(['/admin/org-list']);
      this.util.showLoader = false;
    }, (err) => {
      this.util.showLoader = false;
      this.serviceError = err.responseHead
        ? this.util.getIntlErrorMessage("MANAGE_ADMINS", err.responseHead.statusCode, err.responseHead.statusDesc)
        : err;
      this.util.simpleDialog({
        title: 'Error',
        message: this.serviceError,
      });
      this.route.navigate(['/admin/org-list']);
    });
  }
}

  onCancelDelete(): void {
    this.closeConfirmDialog();
  }

  private closeConfirmDialog(): void {
    const modal = document.getElementById('confirmDialogModal');
    if (modal) {
      (modal as any).classList.remove('show');
      modal.setAttribute('aria-hidden', 'true');
      modal.style.display = 'none';
    }
    this.selectedAdminToDelete = null; // Clear the selected course
  }

}
